import { render, staticRenderFns } from "./BookingListItem.vue?vue&type=template&id=887132a8&scoped=true"
import script from "./BookingListItem.vue?vue&type=script&lang=js"
export * from "./BookingListItem.vue?vue&type=script&lang=js"
import style0 from "./BookingListItem.vue?vue&type=style&index=0&id=887132a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887132a8",
  null
  
)

export default component.exports